import React, { useEffect } from "react";
import TabContent from "Components/Tabs/TabContent";
import TextAnalysis from "Components/TextAnalysis/TextAnalysis";
import ResponsesAnalysis from "Components/ResponsesAnalysis/ResponsesAnalysis";
import Heatmap from "Components/Heatmap/Heatmap";
import { useDispatch } from "react-redux";
import { getBoard } from "store/slices/board/boardSlice";
import { getCurrentUser } from "store/slices/user/currentUserSlice";
import { useParams } from "react-router-dom";
import "./Boards.scss";

const analysisTabs = [
  {
    key: 1,
    label: "Text Analysis",
    children: <TextAnalysis />,
  },
  {
    key: 2,
    label: "Reactions Analysis",
    children: <ResponsesAnalysis />,
  },
  {
    key: 3,
    label: "Heatmap",
    children: <Heatmap />,
  },
];

// This page is only ever shown inside the MagicBullet BoardDetail.aspx Analytics
// tab iframe (NN-3056), never as a standalone full page - no page chrome/title here.
const Boards = () => {
  const dispatch = useDispatch<any>();

  const { id } = useParams();

  useEffect(() => {
    dispatch(getBoard(Number(id)));
  }, []);

  useEffect(() => {
    dispatch(getCurrentUser());
  }, []);

  // Suppress the horizontal scrollbar so the framed page fits the iframe's
  // tab instead of panning; restore on unmount for other MainLayout routes.
  useEffect(() => {
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "";
    };
  }, []);

  return (
    <div className="boards-embedded">
      <TabContent items={analysisTabs} className={"tabs-as-buttons"} />
    </div>
  );
};

export default Boards;
